import { getOrganizationOfUser } from '@upright/common/iam/organizations/common';
import { isDmaUser } from '@upright/common/utils';
import { useGetLoggedInUser } from '@upright/ui/common/generic/hooks';
import { useFrontPageConfig } from '@upright/ui/views/home-views/front-page-config';
import { type UnifiedShellAudience, unifiedShellAudience } from './unified-shell-audience';

/**
 * The signed-in user's unified shell audience: investor, company or none. The one place the
 * shell, the launcher gate and the rail choice read it from, so the three cannot disagree. See
 * `unifiedShellAudience` for the rule.
 */
export function useUnifiedShellAudience(): UnifiedShellAudience {
  const { frontPage } = useFrontPageConfig();
  const user = useGetLoggedInUser();
  return unifiedShellAudience({
    frontPage,
    organizationType: user ? getOrganizationOfUser(user)?.type : undefined,
    isDmaUser: user ? isDmaUser(user) : false,
  });
}
